<template>
  <div class="container pb-sm-4 pt-4 pb-0">
    <div class="row no-gutters mb-4">
      <div class="d-none d-sm-block col-12 col-sm-4 col-md-6 align-self-center">
        <img :src="getMerchant.image_url" @click="goToHomepage" class="cursor-pointer" height="40" />
      </div>
      <div class="col-12 col-sm-8 align-self-center col-md-6 text-md-right text-center">
        <p @click="toggleDetail()" class="d-table ml-sm-auto ml-0 mx-auto mx-sm-0 body-2-2 cursor-pointer mb-0"><span>{{ `${current_language.name} (${current_language.code})` }}</span> | {{getCurrency.name}} ({{getCurrency.code}})</p>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-4 align-self-start stepper-item" v-for="step_item in stepper">
        <p class="mb-0 body-1-1 text-white title mx-auto mb-3" :class="{'active':step_item.id == step}">{{ step_item.id }}</p>
        <p class="mb-0 desc body-1-1 text-center font-hw" :class="{'active':step_item.id == step}">{{ step_item.title }}</p>
      </div>
    </div>

    <template v-if="show_detail">
      <div class="position-relative z-index-1045">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-table w-100 nav-bottom" style="top:40px">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-12 col-lg-9 position-relative">
                  <div class="rounded-4 bg-white">
                    <div class="row no-gutters">
                      <div class="col-12 pop-up-currency-language position-relative h-96vh" style="overflow-y: scroll;height: 90vh;">
                        <img src="../../assets/img/icon/cancel.png"
                          class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-4 cursor-pointer position-absolute"
                          width="33" 
                          style="z-index: 1038;right: 0"
                          @click="toggleDetail()">
                          <div class="w-100 py-4 px-5">
                            <p class="mb-4 body-2-2 font-bold text-20 d-block">{{$t('hotel.choose-language')}}</p>
                            <div class="row slim-grid-row">
                              <div class="col-xl-4 col-lg-4 col-md-6 col-6 mb-3 rounded-6 cursor-pointer" @click="changeLanguage(list.iso_code)" :class="{'border-green cur-box-green':getCurrentLanguage == list.iso_code,'cur-box':getCurrentLanguage != list.iso_code}" v-for="list in getMerchant.language">
                                <div class="px-2 py-2 my-1">
                                  <div class="d-inline-block">
                                    <img :src="list.image_url" width="55" height="40" class="position-relative align-bottom rounded-3 object-fit border">
                                  </div>
                                  <div class="ml-2 d-inline-block position-relative" style="top: 1px">
                                    <p 
                                      class="mb-0 body-2-2 text-14 font-semibold text-truncate" 
                                      :class="{'text-green':getCurrentLanguage == list.iso_code}">
                                      {{list.name}}</p>
                                    <p 
                                      class="mb-0 body-2 text-12 font-regular text-uppercase" 
                                      :class="{'text-green':getCurrentLanguage == list.iso_code}">
                                      {{list.iso_code}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="w-100 py-4 px-5">
                            <p class="mb-4 body-2-2 font-bold text-20 d-block">{{$t('hotel.choose-currency')}}</p>
                            <div class="row slim-grid-row">
                              <div class="col-12 col-md-6 col-lg-3 mb-3 rounded-6"
                              :class="{'cur-box': currency.code != getCurrency.code, 'border-green cur-box-green': currency.code == getCurrency.code,'cursor-pointer': !is_load, 'cursor-loading': is_load}"
                              v-for="currency in currencys"
                              @click="changeCurrency(currency)">
                                <div class="p-2">
                                  <p 
                                    class="mb-0 body-2-2 text-14 font-semibold text-truncate" 
                                    style="margin-bottom: -2px"
                                    :class="{'text-green': currency.code == getCurrency.code}">{{currency.name}}</p>
                                  <p 
                                    class="mb-0 body-2 text-14 font-regular"
                                    :class="{'text-green': currency.code == getCurrency.code}">
                                    {{currency.code}} - {{currency.symbol_native}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="position-relative z-index-1042">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-12 position-relative">
                    <div class="">
                      <div class="w-100 py-2 px-2" 
                        style="height: 100vh;background-color: #00000099">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
  import { mapGetters,mapMutations } from 'vuex';
  import currency from "@/data/currency"
  
  export default {
    props: {
      step:{
        type: Number,
        default: 1
      }
    },
    data(){
      return{
        stepper: [
          {id: 1, title: this.$t('ticket.select-ticket')},
          {id: 2, title: this.$t('ticket.payment-method')},
          {id: 3, title: this.$t('ticket.complete')},
        ],
        currencys: currency,
				is_load: false,
        language_selected: "",
        show_detail: false
      }
    },
    computed:{
      ...mapGetters(['getMerchant','getCurrency','getCurrentLanguage']),
      current_language(){
        let return_data = {
          name: 'English',
          iso_code: 'en',
          code: 'EN'
        }
        if(this.getMerchant.language.length > 0){
          let selected_lang = this.getMerchant.language.findIndex(x=>x.iso_code == this.getCurrentLanguage)
          if(selected_lang != -1){
            return_data = this.getMerchant.language[selected_lang]
            return_data.code = return_data.iso_code.toUpperCase() 
          }
        }
        return return_data
      }
    },
    methods:{
      ...mapMutations(['setCurrency','setBaseRate','setLanguageMutation']),
      toggleDetail(){
				this.show_detail = !this.show_detail
			},
			changeCurrency(data){
        this.is_load = true
        this.$convertCurrency(data.code)
        .then(()=>{
          this.setCurrency(data)
          this.toggleDetail()
        })
        .finally(()=>this.is_load)
			},
      changeLanguage(data){
        console.log("data :", data)
        this.setLanguageMutation(data)
        window.location.reload();
      },
      goToHomepage(){
        const query = this.$route.query;
        this.$router.push({
          name: 'MerchantTicketInfo'
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ticket/CustomHeader.vue